import axios from "axios";
import { Message } from "element-ui";
import Rsa from "@/js/Rsa.js";
import { timeFun } from "@/js/public.js";
import { getToken } from "./login.js";

export const urlList = [
  "https://api.hakspay.cn",
  "https://api2.hakspay.cn",
  "https://api3.hakspay.cn",
  "https://pay.swiftpass.cn/pay/gateway",
  "https://test-api.hakspay.cn"
];

/**
 * 表示微信接口通用地址
 * @type {String}
 * @description 表示微信接口通用地址
 */
export const wxbaseurl = "https://mp.weixin.qq.com";

/**
 * wss 地址
 */
export const wssUrl = "wss://test-api.hakspay.cn";

/**
 * 导出请求地址根目录
 */
export const baseUrl = urlList[4];
localStorage.setItem("baseUrl", urlList[4]);
axios.defaults.baseURL = localStorage.getItem("baseUrl");
//TODO:在测试环境中可以打开这段启动跨域配置
// axios.defaults.baseURL = '/abc';
axios.defaults.headers.post["Content-Type"] = "application/json";

/* 公众号id */
export const officialId =
  process.env.NODE_ENV === "development"
    ? "wx59275b1f7f83e45f"
    : "wxf003ddc051b4643b";

/* wx59275b1f7f83e45f test -- 微信公众号测试id */

/**
 * 排除不用加请求头的请求路径
 * 请求白名单
 */
const excludeUrlList = ["v3/common/getsyskey", "v3/wxhelper/login/GetLoginQr", "v3/common/getsyskey", "v3/wxhelper/card/list", "v3/ServiceProvider/common/login", "v3/merchant/common/login", "v3/Membership/Account/login", "v3/wxHelper/login/GetLoginAccessToken"];

//请求拦截器
axios.interceptors.request.use(async function (res) {
  try {
    if (excludeUrlList.indexOf(res.url.split("?")[0]) >= 0) {
      return res;//如果在不用添加请求头列表中，直接返回（不需要令牌的请求）
    }
    const expire_time = new Date(localStorage.getItem("expire_time"));//令牌超时时间
    const now_time = new Date();//当前时间
    //判断有令牌并且不是获取 公钥的接口 在请求头上加 Authorization
    if (
      localStorage.getItem("access_token") &&
      excludeUrlList.indexOf(res.url.split("?")[0]) < 0 && localStorage.getItem("expire_time") &&
      localStorage.getItem("access_token") &&
      expire_time - now_time > 600000
    ) { //判断本地有令牌并且 没有在排除数组中 并且令牌没超时
      res.headers.Authorization = `Token token_type=${localStorage.getItem(
        "token_type"
      )}&access_token=${await $encrypt(localStorage.getItem("access_token"))}`;
    }
    if (
      localStorage.getItem("expire_time") &&
      localStorage.getItem("access_token") &&
      expire_time - now_time > 600000
    ) { //没有超时
      return res; //继续执行
    } else { //已经超时
      if (excludeUrlList.indexOf(res.url) < 0) { //如果请求的是需要令牌的接口 则需要获取令牌
        await getToken();
        /* console.log("令牌已经超时access_token", localStorage.getItem("access_token"));
        console.log("令牌已经超时expire_time", localStorage.getItem("expire_time"));
        console.log("令牌已经超时res.data", res.data);
        console.log("令牌已经超时res" + res.url, res); */
        if (localStorage.getItem("access_token") && excludeUrlList.indexOf(res.url) < 0) {
          res.headers.Authorization = `Token token_type=${localStorage.getItem(
            "token_type"
          )}&access_token=${await $encrypt(localStorage.getItem("access_token"))}`;
        };
        if (res.data.access_token) res.data.access_token = localStorage.getItem("access_token");
        return res;
      } else {
        return res;
      }
    }
    //接口需要令牌的情况
  } catch (e) {
    console.log("出错", e);
    return res;
  }
});

/* import Vue from "vue";
import devVue from "../main-dev.js";
console.log(Vue)
console.log(devVue) */
/* if(process.env.NODE_ENV==="development"){
  _that = devVue
}else if(process.env.NODE_ENV==="production"){
  _that = prodVue
} */

/**
 * timer 一个定时器，设置为一分钟
 * key rsa key
 * count 第几次调用
 */
let timer = null;
let cachedKey = "";
let requestCount = 0;//请求的次数
let isFetching = false; // 防止并发请求
let pendingPromise = null; // 缓存正在进行的请求
/**
 * 获取 RSA 系统公钥
 * https://test-api.hakspay.cn/v3/ePlatform/Service/common/getsyskey
 * @returns
 */
export const getRsaKey = async function () {
  clearTimeout(timer);
  // 1. 如果有缓存且在 1 分钟内，直接返回
  if (requestCount > 0 && cachedKey) {
    //console.log(`第${requestCount}次请求2`, cachedKey);
    return Promise.resolve(cachedKey);
  }
  requestCount++;
  // 2. 如果正在请求中，返回同一个 Promise
  if (isFetching) {
    return pendingPromise;
  }
  // 3. 第一次请求或缓存过期
  isFetching = true;
  pendingPromise = new Promise((resolve, reject) => {
    axios.get("v3/common/getsyskey")//common/v2/getsyskey
      .then((res) => {
        if (res.data?.public_key) {
          cachedKey = res.data.public_key;
          isFetching = false;

          resolve(cachedKey);
        } else {
          isFetching = false;

          reject(new Error("未获取到key"));
        }
      })
      .catch((error) => {
        Message.error(error.message);
        isFetching = false;
        reject(error);
      })
      .finally(() => {
        isFetching = false;
      });
  });
  timer = setTimeout(() => {
    requestCount = 0;
  }, 60000);
  return pendingPromise;
};

/**
 * 节流函数
 * @returns rsakey
 *//*
export const antiShake = async function() {
clearTimeout(timer);
if (count == 0) {
console.log("count==0数量等于0");
key = await getRsaKey();
}
count++;
timer = setTimeout(() => {
count = 0;
console.log("重新开始");
}, 60000);
console.log(`第--${count}--次调用！`);
return key;
}; */

/**
 * rsa加密
 * @param {string} str 需要加密的值
 * @param {string} key  需要加密值的字段名
 * @returns 加密后的值
 */
export const $encrypt = async function (str, key) {
  const rsakey = await getRsaKey();
  return Rsa.encrypt(
    JSON.stringify({
      time_stamp: timeFun("eng"),
      plaintext: str
    }),
    rsakey
  );
};

export const testR = function (res) {
  // Message.error(JSON.stringify(res));
  if (res.data.return_code === "FAIL" || res.data.return_msg) {
    Message.error(res.data.return_msg);
    return false;
  } else if (res.data.result_code === "FAIL" || res.data.result_msg) {
    Message.error(res.data.result_msg);
    return false;
  } else if (res.data.error_code === "FAIL" || res.data.error_msg) {
    Message.error(res.data.error_msg);
    return false;
  } else if (
    res.data.return_code === "SUCCESS" &&
    res.data.result_code === "SUCCESS" &&
    res.data.resp_data &&
    res.data.resp_data.isSuccess === false
  ) {
    Message.error(res.data.resp_data.msg);
    return false;
  } else if (
    res.data.return_code === "SUCCESS" &&
    res.data.result_code === "SUCCESS" &&
    res.data.resp_data
  ) {
    return true;
  }
};
/**
 * 封装的post接口
 * @param {string} url 请求的地址
 * @param {object} data 需要提交的请求数据
 * @returns 返回 testR测试后的数据
 */
export const $asyncPost = function (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(res => {
      if (testR(res)) {
        resolve(res.data.resp_data);
      } else {
        resolve(res);
      }
    }).catch((e) => {
      Message.error(e);
      resolve(false);
    })
  })
};

export const $asyncGet = function (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url).then(res => {
      if (testR(res)) {
        resolve(res.data.resp_data);
      } else {
        resolve(res);
      }
    }).catch((e) => {
      Message.error(e);
    })
  })
};

export default axios;
